import { camelCase, capitalize } from 'lodash-es';
import messages from './messages.json';

export default function getCategoryPath(category, hasLocalNews, intl) {
  const path = category.path.replace(/\/.+/, '');

  return capitalize(hasLocalNews
    ? path
    : intl.formatMessage(messages[camelCase(path)]));
}
